export default {
  methods: {
    minSearchSubmit() {
      this.pageSize = 10;
      this.currentPage = 1;
      for (const key in this.queryParams) {
        if (typeof this.queryParams[key] === 'number') {
          this.queryParams[key] = this.queryParams[key] + '';
        }
        if (typeof this.queryParams[key] === 'string') {
          this.queryParams[key] = this.queryParams[key].trim();
        }
      }
      this.querySubmit();
    },
    resetQueryParams() {
      if (this.initQueryParams) {
        for (const key in this.queryParams) {
          this.queryParams[key] = this.initQueryParams[key];
        }
      } else {
        for (const key in this.queryParams) {
          this.queryParams[key] = '';
        }
      }
    }
  }
};
